import { Box, Typography } from '@mui/material';
import { FONT_SERIF, WD } from '../../../warningDashboard/warningTheme';
import { CARD_BG, FIGURE, LEVEL_TONE } from '../utils/constants';

/** A small figure tile in the drawer - Allocated, Capacity, Free / Excess. `alarm` turns it red. */
export default function MiniFigure({ label, value, alarm = false }) {
  return (
    <Box sx={{ borderRadius: 3, px: 1.75, py: 1.5, bgcolor: alarm ? LEVEL_TONE.overloaded.bg : CARD_BG, border: `1px solid ${alarm ? LEVEL_TONE.overloaded.accent : WD.border}` }}>
      <Typography sx={{ fontSize: 11.5, fontWeight: 600, color: alarm ? LEVEL_TONE.overloaded.text : WD.inkMuted }}>{label}</Typography>
      <Typography sx={{ mt: 0.5, fontFamily: FONT_SERIF, fontSize: 22, fontWeight: 600, lineHeight: 1, ...FIGURE, color: alarm ? LEVEL_TONE.overloaded.text : WD.ink }}>
        {value}
      </Typography>
    </Box>
  );
}
